import Blank from "@/layouts/blank.vue";
import DraftSubHireList from "@/pages/admin/draft-subhire/DraftSubHireList.vue";

const draftSubHireRoutes = [
  {
    path: "draft-subhire",
    name: "app-admin-draft-subhire",
    component: Blank,
    children: [
      {
        path: "/",
        redirect: "/app/admin/draft-subhire/list",
      },
      {
        path: "list",
        name: "app-admin-draft-subhire-list",
        component: DraftSubHireList,
      },
    ],
  },
];

export default draftSubHireRoutes;
